import { IService } from '../../../types/model.types';
import { IBlockAttr } from '~/components/Builder/BuilderSidebar/builder-sidebar.types';

export const ServiceItemKeys = getWhitelistedKeys<IService>({
    title: true,
    price: true,
    price_per_unit: true,
    quantity: true,
    description: true,
    unit: true,
    tax_1: true,
    tax_2: true,
    tax_3: true,
    qb_item_id: true
});

function getWhitelistedKeys<T>(config: { [key in keyof T]: boolean }) {
    return Object.entries(config)
        .filter(([, value]) => !!value)
        .map(([key]) => key as keyof T);
}

export const SERVICE_ITEM_SIDEBAR_ATTRIBUTES: Record<string, IBlockAttr> = {
    tax_1: {
        key: 'service_item.tax_1',
        label: 'Tax',
        type: 'toggle',
        defaultValue: false,
        inline: true
    },
    tax_2: {
        key: 'service_item.tax_2',
        label: 'SVC',
        type: 'toggle',
        defaultValue: false,
        inline: true
    },
    tax_3: {
        key: 'service_item.tax_3',
        label: 'Tax 3',
        type: 'toggle',
        defaultValue: false,
        inline: true
    },
    show_image: {
        key: 'show_image',
        label: 'Show an image',
        type: 'toggle',
        defaultValue: false,
        isStyleAttr: true,
        inline: true,
        disabled: false
    }
};
